import React, {forwardRef, useMemo} from 'react';
import PropTypes from 'prop-types';
import DatePicker, { /*registerLocale*/ } from 'react-datepicker';
import SMCTextInput from '../SMCTextInput';
import './styles.css'
import SMCButton from '../SMCButton';
import { makeStyles } from '@mui/styles';
import {useSMCDisabledContext} from '../SMCDisabledContext';
import {hasValue} from '../../../utils/utils';


function SMCDayPickerInput({
    placeholder,
    disabled=false,
    ignoreDisabledContext,
    value,
    onChange,
    width=100,
    noFuture,
    maxDate,
    minDate,
    showTimeSelect,
    showTimeSelectOnly
}) {
    const classes = useStyles();
    const disabledContext = useSMCDisabledContext();
    
    const _disabled = useMemo(() => {
        if (disabledContext && !ignoreDisabledContext) {
            if (disabledContext.forceDisable) {
                return true;
            }
            if (disabledContext.forceEnable) {
                return false;
            }
        }
        if (hasValue(disabled)) {
            return disabled;
        }
        return undefined;
    }, [disabled, disabledContext, ignoreDisabledContext]);

    const inputRef = React.createRef();
    const CustomInput = forwardRef(({ onClick, value }, ref) => (
        <SMCTextInput
            className={classes.dateInput}
            onClick={onClick}
            value={value}
            onChange={onClick}
            disabled={_disabled}
            width={width}
            placeholder={placeholder}
            innerRef={inputRef}
        />
    ));
    
    const _maxDate = useMemo(() => {
        if (maxDate) {
            return maxDate;
        } else if (noFuture) {
            return new Date();
        } else {
            return undefined;
        }
    }, [maxDate, noFuture]);

    let dateFormat;
    if (showTimeSelectOnly) {
        dateFormat = 'HH:mm'; // 16:30 (Only time)
    } else if (showTimeSelect) {
        dateFormat = 'dd/MM/yyyy HH:mm'; // 30/12/2020 - 16:30 (Date and time)
    } else {
        dateFormat = 'dd/MM/yyyy'; // 30/12/2020 (Only date)
    }
    

    return (
        <div>
            <DatePicker
                popperModifiers={{
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: "scrollParent"
                    }
                }}
                selected={value}
                onChange={onChange}
                disabled={_disabled}
                maxDate={_maxDate}
                minDate={minDate}
                customInput={<CustomInput ref={inputRef} />}
                showTimeSelect={showTimeSelect}
                showTimeSelectOnly={showTimeSelectOnly}
                dateFormat={dateFormat}
            />
            <SMCButton
                className={classes.dateButton}
                icon="calendar"
                onClick={() => {
                    inputRef.current.focus();
                    inputRef.current.click();
                }}
            />
        </div>
    );
}

const useStyles = makeStyles({
    dateInput: {
        marginRight: '0'
    },
    dateButton: {
        marginLeft: '0',
        height: '24px',
        position: 'relative',
        top: '3px',
        width: '28px',
        paddingLeft: '5px',
        paddingRight: '0'
    }
});

SMCDayPickerInput.propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.object,
    onChange: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    ignoreDisabledContext: PropTypes.bool
}

export default React.memo(SMCDayPickerInput);